<template>
  <div class="promo-code-input">
    <div class="form-group row clearfix" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="value"
          @input="validateField($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'
import Api from '@/vuex/api'

export default {
  name: 'PromoCodeInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          unique: false,
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      isUnique: true,
      isDirty: false,
      isLoading: false,
      delayedValidate: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      if (this.options.unique && !this.isUnique) {
        return this.options.label + ' is already taken'
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  methods: {
    async checkPromoCode () {
      this.isLoading = true
      try {
        let instance = new Api()
        let data = await instance.checkPromoCode({
          checkVal: this.value
        })
        this.isLoading = false
        this.isUnique = this.isValid = data.unique
      } catch (e) {
        this.isLoading = false
        this.isUnique = false
        this.isValid = false
      }
    },
    validateField (val = this.value) {
      this.$emit('input', val)
      if (this.delayedValidate) {
        this.delayedValidate.cancel()
        this.delayedValidate = false
      }
      this.delayedValidate = _.debounce(async (val) => {
        await this.checkPromoCode()
      }, 1500, { 'leading': false, 'trailing': true })
      this.validate(val)
      if (this.options.unique && this.isValid) {
        this.delayedValidate(val)
      }
    },
    validate (val = this.value) {
      if (val) {
        this.isDirty = true
        this.isValid = true
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PromoCodeInput.vue